import { useEffect, useState } from "react";
import { toast } from "sonner";
import { http } from "@/lib/api";
import { Card, btnPrimary, fieldCls } from "@/components/portal/ui";
import { money } from "@/lib/constants";

export default function AdminProducts() {
  const [products, setProducts] = useState([]);
  const load = () => http.get("/admin/products").then((r) => setProducts(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  return (
    <div>
      <div className="eyebrow text-[#8A998C] mb-1">Product Management</div>
      <h1 className="font-display text-3xl text-[#1A1918] mb-1">Consulting Products</h1>
      <p className="text-[#6B665E] text-sm mb-8">Modular settings. Changing these never requires rebuilding the property.</p>
      <div className="space-y-4">{products.map((p) => <ProductRow key={p.key} p={p} onSaved={load} />)}</div>
    </div>
  );
}

function ProductRow({ p, onSaved }) {
  const [f, setF] = useState({ name: p.name, price: p.price, availability: p.availability, capacity_limit: p.capacity_limit,
    turnaround: p.fulfillment_rules?.turnaround || "", response_window: p.fulfillment_rules?.response_window || "" });
  const set = (k, v) => setF((x) => ({ ...x, [k]: v }));
  const save = async () => {
    try {
      await http.put(`/admin/products/${p.key}`, {
        name: f.name, price: Number(f.price), availability: f.availability, capacity_limit: Number(f.capacity_limit),
        fulfillment_rules: { ...p.fulfillment_rules, turnaround: f.turnaround, response_window: f.response_window },
      });
      toast.success("Saved"); onSaved();
    } catch (e) { toast.error("Could not save"); }
  };

  return (
    <Card className="p-6">
      <div className="flex items-center justify-between mb-4">
        <span className="text-xs px-2 py-0.5 rounded-full bg-[#9F634E]/10 text-[#9F634E]">Level {p.level} · {p.purpose}</span>
        <span className="text-xs text-[#6B665E]">{p.availability_status?.open_count}/{p.capacity_limit} open · {p.availability_status?.status}</span>
      </div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        <Field label="Name"><input className={fieldCls} value={f.name} onChange={(e) => set("name", e.target.value)} /></Field>
        <Field label="Price (USD)"><input type="number" data-testid={`prod-price-${p.key}`} className={fieldCls} value={f.price} onChange={(e) => set("price", e.target.value)} /></Field>
        <Field label="Availability">
          <select className={fieldCls} value={f.availability} onChange={(e) => set("availability", e.target.value)}>
            <option value="active">Active</option><option value="paused">Paused</option>
          </select>
        </Field>
        <Field label="Capacity limit"><input type="number" className={fieldCls} value={f.capacity_limit} onChange={(e) => set("capacity_limit", e.target.value)} /></Field>
        <Field label="Turnaround"><input className={fieldCls} value={f.turnaround} onChange={(e) => set("turnaround", e.target.value)} /></Field>
        <Field label="Response window"><input className={fieldCls} value={f.response_window} onChange={(e) => set("response_window", e.target.value)} /></Field>
      </div>
      <div className="mt-4 flex items-center justify-between">
        <span className="text-[#6B665E] text-sm">Current: {money(p.price)}</span>
        <button onClick={save} data-testid={`prod-save-${p.key}`} className={btnPrimary}>Save changes</button>
      </div>
    </Card>
  );
}
function Field({ label, children }) { return <div><label className="block text-xs text-[#8A998C] uppercase tracking-wide mb-1.5">{label}</label>{children}</div>; }
